var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown",
    _vm._g(
      _vm._b(
        {
          staticClass: "sk-p2-dropdown",
          attrs: {
            trigger: _vm.trigger,
            placement: _vm.placement,
            disabled: _vm.disabled,
          },
          on: {
            command: _vm.handleCommand,
            "visible-change": _vm.handleVisibleChange,
          },
        },
        "el-dropdown",
        _vm.$attrs,
        false
      ),
      _vm.dropdownListeners
    ),
    [
      _vm._t("default", function () {
        return [
          _c(
            "Phase2ActionButton",
            {
              style: { minWidth: _vm.minWidth },
              attrs: {
                type: _vm.buttonType,
                size: _vm.buttonSize,
                disabled: _vm.disabled,
                loading: _vm.loading,
              },
            },
            [
              _vm.buttonIcon ? _c("i", { class: _vm.buttonIcon }) : _vm._e(),
              _c("span", [_vm._v(_vm._s(_vm.label))]),
              _c("i", {
                class: [
                  _vm.arrowIcon,
                  "sk-p2-dropdown__arrow",
                  { "is-active": _vm.isVisible },
                ],
              }),
            ]
          ),
        ]
      }),
      _c(
        "el-dropdown-menu",
        {
          class: _vm.computedMenuClass,
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _vm.items && _vm.items.length
            ? [
                _vm._l(_vm.items, function (item, index) {
                  return [
                    _c(
                      "el-dropdown-item",
                      {
                        key: item.command || index,
                        class: [
                          item.danger ? "is-danger" : "",
                          item.customClass || "",
                        ],
                        attrs: {
                          command: item.command,
                          disabled: item.disabled,
                          divided: item.divided,
                        },
                      },
                      [
                        item.icon ? _c("i", { class: item.icon }) : _vm._e(),
                        _c("span", [_vm._v(_vm._s(item.label))]),
                      ]
                    ),
                  ]
                }),
              ]
            : _vm._t("dropdown"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }